import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RegisterTimeButton from "./Button";
import Todo from 'src/store/models/Todo';
import Project from 'src/store/models/Project';
export default {
  components: {
    RegisterTimeButton: RegisterTimeButton
  },
  props: {
    todoId: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    myUser: function myUser() {
      var _this = this;

      return this.todo.users_with_entries.find(function (user) {
        return user.user_id === _this.me.user_id;
      });
    },
    otherUsers: function otherUsers() {
      var _this2 = this;

      return this.todo.users_with_entries.filter(function (user) {
        return user.user_id !== _this2.me.user_id;
      });
    },
    todo: function todo() {
      return Todo.query().with('todo_list.project').find(this.todoId);
    },
    canTrackTime: function canTrackTime() {
      var _this$todo$todo_list;

      // eslint-disable-next-line camelcase
      var project = Project.find((_this$todo$todo_list = this.todo.todo_list) === null || _this$todo$todo_list === void 0 ? void 0 : _this$todo$todo_list.project_id);
      return !project || project.is_active && Project.$isUserMember(this.todo.todo_list.project_id, this.me.user_id);
    }
  },
  methods: {
    openEntriesDialog: function openEntriesDialog(userId) {
      this.openDialog('EntriesDialog', {
        filters: {
          member_ids: [userId],
          todo_ids: [this.todoId]
        }
      });
    }
  }
};